module.exports = __webpack_public_path__ + "static/media/B1.8b54fd89.svg";